import * as CyberCareActions from './../actions/cyber-care.actions';
import { TechnicalError } from '@dch/products-business-logic';

export interface CyberCareState {
  price: any;
  isPendingPrice: boolean;
  errorPrice: TechnicalError;
}

export const initialState: CyberCareState = {
  price: [],
  isPendingPrice: false,
  errorPrice: null,
};

export function reducer(
  state: CyberCareState = initialState,
  action: CyberCareActions.Actions,
): CyberCareState {
  switch (action.type) {
    case CyberCareActions.GET_CYBER_CARE_PRODUCT_PRICE:
      return {
        ...state,
        isPendingPrice: true,
        errorPrice: null,
      };
    case CyberCareActions.GET_CYBER_CARE_PRODUCT_PRICE_SUCCESS:
      return {
        ...state,
        price: action.payload.responses[0],
        isPendingPrice: false,
        errorPrice: null,
      };
    case CyberCareActions.GET_CYBER_CARE_PRODUCT_PRICE_FAILED:
      return {
        ...state,
        price: null,
        errorPrice: action.payload,
        isPendingPrice: false,
      };
    default:
      return state;
  }
}

export const getProductsPrice = (state: CyberCareState) => state.price;
export const getProductsPriceTechnicalError = (state: CyberCareState) =>
  state.errorPrice;
export const getProductsPricePending = (state: CyberCareState) =>
  state.isPendingPrice;
